import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const PageTitle = styled.div`
    padding-top: 9px;
    padding-bottom: 9px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const ContainerRight = styled.div`
    padding-left: 10px;
    height: 100%;

    @media screen and (max-width: 767px) {
        padding-left: 0;
    }
`

export const ContainerLeft = styled.div`
    margin-right: 10px;

    @media screen and (max-width: 767px) {
        margin: 0;
    }
`

export const PageTitleLeft = styled.div``

export const PageTitleRight = styled.div``

export const CategoryName = styled(Link)`
    text-decoration: none;
    font-size: 19px;
    font-weight: bold;
    color: #333;
    text-transform: uppercase;
    padding-left: 8px;
    position: relative;
    white-space: nowrap;

    &:before {
        width: 4px;
        height: 22px;
        background-color: #e32;
        content: '';
        display: block;
        position: absolute;
        left: 0;
    }

    @media screen and (max-width: 767px) {
        font-size: 15px;

        &:before {
            height: 18px;
        }
    }

    @media screen and (max-width: 320px) {
        font-size: 14px;
        &:before {
            height: 18px;
        }
    }
`

export const NewsTitle = styled.h1`
    color: #e32;
    font-size: 32px;
    font-weight: bold;
    line-height: 1.25;
    margin: 10px 0;

    @media screen and (max-width: 767px) {
        font-size: 24px;
    }
`

export const CreatedAt = styled.p`
    color: #727b88;
    font-size: 12px;
    margin-bottom: 12px;
`

export const NewsDescription = styled.h2`
    color: #222;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 12px;
    letter-spacing: -.2px;
    font-weight: bold;
`

export const NewsBody = styled.div`
    & figure {
        text-align: center;
        margin-bottom: 24px;
    }

    & img {
        width: 100%;
    }

    & p {
        color: #222;
        margin-bottom: 24px;
        line-height: 1.44;
        margin-bottom: 24px;
        letter-spacing: -.2px;
        font-size: 16px;
    }

    & figcaption {
        padding: 5px 8px;
        margin-bottom: 24px;
        background: #e9e9e9;
        color: #222;
        font-size: 12px;
        opacity: .7;
        line-height: 1.45;
        letter-spacing: -.2px;
        margin-top: -5px;
    }

    & a {
        text-decoration: none;
    }
`
export const BodyWrap = styled.div`
    display: flex;
`

export const NewsContent = styled.div`
    margin-left: 20px;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        margin: 0;
    }

    @media screen and (max-width: 767px) {
        margin: 0;
    }
`

export const AuthorWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
    align-items: center;
    font-size: 13px;
`

export const Author = styled.p`
    color: #222;
    font-size: 13px;
    font-weight: bold;
    margin-left: 5px;
    text-transform: uppercase;
`

export const CmtFormBg = styled.div`
    background-color: rgba(34,34,34,.05);
    padding: 16px;
    scroll-margin-top: 55px;
`

export const CmtTotal = styled.p`
    margin-top: 16px;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #222;
`

